/** Safari tab versus Home Screen app; no claim about permission persistence follows from this detection. */
export function iphoneSafari(nav: Pick<Navigator, 'userAgent'> | undefined = globalThis.navigator): boolean {
  const ua = nav?.userAgent ?? '';
  return /iPhone|iPod/.test(ua) && /Safari\//.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
}
export function iphoneHomeScreen(): boolean {
  return /iPhone|iPod/.test(globalThis.navigator?.userAgent ?? '') && ((globalThis.navigator as Navigator & { standalone?: boolean } | undefined)?.standalone === true
    || globalThis.matchMedia?.('(display-mode: standalone)').matches === true);
}

/** One automatic attempt per app session; an explicit Allow button can always retry. */
export function onFirstPhoneGesture(target: EventTarget, request: () => void): () => void {
  let attempted = false;
  const gesture = (event: Event) => {
    if (!event.isTrusted || attempted) return;
    attempted = true;
    remove();
    request();
  };
  const remove = () => { target.removeEventListener('pointerdown', gesture, true); target.removeEventListener('click', gesture, true); };
  target.addEventListener('pointerdown', gesture, true);
  target.addEventListener('click', gesture, true);
  return remove;
}
